import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { BackButton } from "src/components/base/button";
import TabLayout from "src/components/base/tab-layout";
import { Tab, TabMenu } from "src/components/base/tab-menu";
import SINGLE_TAG_CONTEXT, { SingleTagProvider } from "src/context/customer/tag";

/**
 * The properties for {@link CustomerSingleTagView}
 */
export type CustomerSingleTagViewProps = {};

/**
 * $END$
 */
export default function CustomerSingleTagView(props: CustomerSingleTagViewProps) {
    const [t] = useTranslation("customer-tag");

    const { tagId } = Route.useParams();

    return (
        <SingleTagProvider uuid={tagId}>
            <SINGLE_TAG_CONTEXT.Consumer>
                {(ctx) => (
                    <div className={"flex flex-col gap-6"}>
                        <BackButton className={"self-start"} href={"/c/tags"}>
                            {t("button.back-to-tag-overview")}
                        </BackButton>

                        <TabLayout
                            heading={t("heading.tag", { tag: ctx.tag.name })}
                            tabs={
                                <TabMenu>
                                    <Tab href={"/c/tags/$tagId/associated"} params={{ tagId }}>
                                        {t("label.associated-devices")}
                                    </Tab>
                                    <Tab href={"/c/tags/$tagId/inbound-acls"} params={{ tagId }}>
                                        {t("label.inbound-acls")}
                                    </Tab>
                                    <Tab href={"/c/tags/$tagId/outbound-acls"} params={{ tagId }}>
                                        {t("label.outbound-acls")}
                                    </Tab>
                                </TabMenu>
                            }
                        >
                            <Outlet />
                        </TabLayout>
                    </div>
                )}
            </SINGLE_TAG_CONTEXT.Consumer>
        </SingleTagProvider>
    );
}

export const Route = createFileRoute("/_customer/c/tags/$tagId/_tags")({
    component: CustomerSingleTagView,
});
